(() => {
  window.KOB_DASHBOARD_MAKEUP_DYNAMIC_V2 = true;
  document.querySelectorAll("[data-kob-owner-summary-section], [data-kob-partner-request-section]")
    .forEach((section) => { section.dataset.bound = "true"; });
  const language = (document.documentElement.lang || "en").slice(0,2);
  const copy = {
    customer: "Customer",
    allPartners: "All partners",
    partnerConfirmed: "Partner confirmed",
    supplier: "Supplier",
    buffer: "Buffer",
    addOn: "Add-on",
    partnerRecords: "Partner records",
    myRequest: "My request",
    otherPartners: "Other partners",
    change: "Change",
    afterSubmit: "After submit",
    noChanges: "No changes",
    staged: "change staged",
    stagedPlural: "changes staged",
    submitting: "Submitting...",
    saved: "Saved.",
    submitFailed: "Submit failed. Please try again later.",
    missingToken: "This account does not have a request token configured.",
    live: "Live",
    snapshot: "Snapshot",
    noPartnerRequests: "No partner requests recorded.",
  };

  const partnerNames = { KOB1003: "Kai", Azzurr0: "Dai" };
  const number = (value) => Number(value || 0) || 0;
  const clamp = (value) => Math.min(Math.max(Number.parseInt(String(value || "0"), 10) || 0, 0), 1);
  const escapeHtml = (value) => String(value ?? "").replace(/[&<>"']/g, (char) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
  }[char]));
  const fmtAlias = (alias) => (alias && partnerNames[alias] ? partnerNames[alias] : alias || "");
  const cssEscape = window.CSS && window.CSS.escape
    ? window.CSS.escape.bind(window.CSS)
    : (value) => String(value).replace(/[^a-zA-Z0-9_-]/g, "\\$&");

  const postJson = async (endpoint, payload) => {
    const response = await fetch(endpoint, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(payload),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok || !data.ok) throw new Error(data.error || "request_failed");
    return data;
  };

  const codeButton = (row) => {
    const code = escapeHtml(row.variant_code || "");
    const title = escapeHtml(row.product_title || row.variant_code || "");
    const image = escapeHtml(row.image_url || "");
    const url = escapeHtml(row.product_url || "");
    return `<button type="button" class="kob-pd-code-button" data-kob-product-preview data-code="${code}" data-title="${title}" data-image="${image}" data-url="${url}">${code}</button>`;
  };

  const partnerRequestText = (text) => String(text || "")
    .split(",")
    .map((item) => {
      const parts = item.split(":");
      if (parts.length < 2) return item.trim();
      return `${fmtAlias(parts[0].trim())}:${parts.slice(1).join(":").trim()}`;
    })
    .filter(Boolean)
    .join(", ");

  const setMetrics = (section, totals) => {
    Object.entries(totals || {}).forEach(([key, value]) => {
      const cell = section.querySelector(`[data-kob-owner-total-cell="${cssEscape(key)}"]`);
      if (cell) cell.textContent = String(number(value));
    });
  };

  const ownerRowHtml = (row) => `
    <tr data-kob-owner-summary-row="${escapeHtml(row.variant_code)}"${number(row.addon_needed_qty) > 0 ? ' class="is-alert"' : ""}>
      <td data-label="Code"><strong>${codeButton(row)}</strong></td>
      <td data-label="${copy.customer}" data-kob-owner-summary-cell="customer_preorder_qty">${number(row.customer_preorder_qty)}</td>
      <td data-label="${copy.allPartners}" data-kob-owner-summary-cell="partner_requested_qty">${number(row.partner_requested_qty)}</td>
      <td data-label="${copy.partnerConfirmed}" data-kob-owner-summary-cell="partner_confirmed_qty">${number(row.partner_confirmed_qty)}</td>
      <td data-label="${copy.supplier}" data-kob-owner-summary-cell="supplier_ordered_qty">${number(row.supplier_ordered_qty)}</td>
      <td data-label="${copy.buffer}" data-kob-owner-summary-cell="buffer_qty">${number(row.buffer_qty)}</td>
      <td data-label="${copy.addOn}" data-kob-owner-summary-cell="addon_needed_qty">${number(row.addon_needed_qty)}</td>
      <td data-label="${copy.partnerRecords}" data-kob-owner-summary-cell="partner_requests">${escapeHtml(partnerRequestText(row.partner_requests))}</td>
    </tr>`;

  const contextCopy = ({zh:{batch:"查看批次",load:"读取",scope:"已读取批次",legacy:"历史需求状态",gap:"当前供应商缺口"},ja:{batch:"表示するロット",load:"取得",scope:"取得したロット",legacy:"記録時の要望状態",gap:"現在の発注不足"}})[language] || {batch:"View batch",load:"Load",scope:"Loaded batch",legacy:"Recorded request status",gap:"Current supplier gap"};
  const renderOwner = (section, payload) => {
    section.dataset.releaseId = payload.release_id || section.dataset.releaseId || "";
    setMetrics(section, payload.totals || {});
    const tbody = section.querySelector("tbody");
    if (tbody) tbody.innerHTML = (payload.rows || []).map(ownerRowHtml).join("");
    const log = section.querySelector("[data-kob-owner-request-log]");
    if (log) {
      const requests = (payload.requests || []).filter((row) => number(row.requested_qty) > 0);
      log.innerHTML = requests.length
        ? requests.map((row) => { const coverage=(payload.rows || []).find(item => String(item.variant_code).toUpperCase() === String(row.variant_code).toUpperCase());return `<li>${escapeHtml(fmtAlias(row.partner_alias))} / ${escapeHtml(String(row.variant_code || "").toUpperCase())}: ${number(row.requested_qty)} (${contextCopy.legacy}: ${escapeHtml(row.status || "recorded")} · ${contextCopy.gap}: ${coverage ? number(coverage.addon_needed_qty) : "—"})</li>`; }).join("")
        : `<li>${copy.noPartnerRequests}</li>`;
    }
    window.dispatchEvent(new CustomEvent("kob:makeup-summary-updated", {
      detail: { release_id: payload.release_id || "", totals: payload.totals || {} },
    }));
  };

  const cardHtml = (row, request, alias) => {
    const code = String(row.variant_code || "").toUpperCase();
    const own = clamp(request?.requested_qty ?? request?.quantity ?? 0);
    const total = number(row.partner_requested_qty);
    const other = Math.max(total - own, 0);
    return `
      <article class="kob-pd-request-card" data-kob-partner-request-row="${escapeHtml(code)}" data-current="${own}" data-delta="0">
        <div class="kob-pd-card-main">
          <strong>${codeButton(row)}</strong>
          <span>${copy.myRequest} (${escapeHtml(fmtAlias(alias))}): <b data-kob-partner-request-cell="own_requested_qty">${own}</b></span>
        </div>
        <div class="kob-pd-card-stats">
          <span>${copy.customer}: <b data-kob-partner-request-cell="customer_preorder_qty">${number(row.customer_preorder_qty)}</b></span>
          <span>${copy.otherPartners}: <b data-kob-partner-request-cell="other_partner_requested_qty">${other}</b></span>
          <span>${copy.allPartners}: <b data-kob-partner-request-cell="partner_requested_qty">${total}</b></span>
          <span>${copy.supplier}: <b data-kob-partner-request-cell="supplier_ordered_qty">${number(row.supplier_ordered_qty)}</b></span>
          <span>${copy.buffer}: <b data-kob-partner-request-cell="buffer_qty">${number(row.buffer_qty)}</b></span>
          <span>${copy.addOn}: <b data-kob-partner-request-cell="addon_needed_qty">${number(row.addon_needed_qty)}</b></span>
        </div>
        <div class="kob-pd-adjust">
          <button type="button" class="kob-pd-icon-button" data-kob-delta="-1" aria-label="Decrease">-</button>
          <div class="kob-pd-adjust-readout"><span>${copy.change}</span><strong data-kob-adjust-label>0</strong></div>
          <button type="button" class="kob-pd-icon-button" data-kob-delta="1" aria-label="Increase">+</button>
        </div>
        <div class="kob-pd-after">${copy.afterSubmit}: <strong data-kob-after>${own}</strong></div>
        <input type="hidden" data-kob-partner-request-code="${escapeHtml(code)}" data-existing="${own}" value="${own}">
      </article>`;
  };

  const setCard = (card, current, delta) => {
    current = clamp(current);
    delta = Math.max(-1, Math.min(1, Number.parseInt(String(delta || "0"), 10) || 0));
    let after = clamp(current + delta);
    delta = after - current;
    card.dataset.current = String(current);
    card.dataset.delta = String(delta);
    card.classList.toggle("is-dirty", delta !== 0);
    const input = card.querySelector("[data-kob-partner-request-code]");
    if (input) {
      input.value = String(after);
      input.dataset.existing = String(current);
    }
    const own = card.querySelector('[data-kob-partner-request-cell="own_requested_qty"]');
    if (own) own.textContent = String(current);
    const label = card.querySelector("[data-kob-adjust-label]");
    if (label) label.textContent = delta > 0 ? `+${delta}` : String(delta);
    const afterEl = card.querySelector("[data-kob-after]");
    if (afterEl) afterEl.textContent = String(after);
    card.querySelectorAll("[data-kob-delta]").forEach((button) => {
      const step = Number(button.dataset.kobDelta || 0);
      button.disabled = (step < 0 && after <= 0) || (step > 0 && after >= 1);
    });
  };

  const bindCards = (section) => {
    const refreshCount = () => {
      const dirty = Array.from(section.querySelectorAll(".kob-pd-request-card"))
        .filter((card) => Number(card.dataset.delta || 0) !== 0).length;
      const count = section.querySelector("[data-kob-change-count]");
      const button = section.querySelector("[data-kob-partner-request-submit]");
      if (count) count.textContent = dirty ? `${dirty} ${dirty > 1 ? copy.stagedPlural : copy.staged}` : copy.noChanges;
      if (button) button.disabled = dirty === 0;
    };
    section.querySelectorAll(".kob-pd-request-card").forEach((card) => {
      setCard(card, card.dataset.current || 0, 0);
      card.querySelectorAll("[data-kob-delta]").forEach((button) => {
        button.addEventListener("click", () => {
          setCard(card, card.dataset.current || 0, Number(card.dataset.delta || 0) + Number(button.dataset.kobDelta || 0));
          const message = section.querySelector("[data-kob-partner-request-message]");
          if (message) message.textContent = "";
          refreshCount();
        });
      });
    });
    refreshCount();
  };

  const renderPartner = (section, payload, alias) => {
    section.dataset.releaseId = payload.release_id || section.dataset.releaseId || "";
    const requests = new Map((payload.requests || []).map((row) => [String(row.variant_code || "").toUpperCase(), row]));
    const grid = section.querySelector(".kob-pd-request-grid");
    if (grid) grid.innerHTML = (payload.rows || []).map((row) => cardHtml(row, requests.get(String(row.variant_code || "").toUpperCase()), alias)).join("");

    const oldButton = section.querySelector("[data-kob-partner-request-submit]");
    if (oldButton && oldButton.dataset.kobDynamicBound !== "true") {
      const button = oldButton.cloneNode(true);
      button.dataset.kobDynamicBound = "true";
      oldButton.replaceWith(button);
      button.addEventListener("click", () => submitPartner(section).catch(() => {
        const message = section.querySelector("[data-kob-partner-request-message]");
        if (message) message.textContent = copy.submitFailed;
      }));
    }
    bindCards(section);
  };

  const sectionPayload = (section, action) => ({
    action,
    release_id: section.dataset.releaseId || "",
    email: section.querySelector("[data-kob-partner-email], [data-kob-owner-email]")?.value || "",
    partner_alias: section.querySelector("[data-kob-partner-alias], [data-kob-owner-alias]")?.value || "",
    partner_token: section.querySelector("[data-kob-partner-token], [data-kob-owner-token]")?.value || "",
  });

  const refreshOwner = async (section, requestedRelease) => {
    const status = section.querySelector("[data-kob-owner-refresh-status]");
    const payload = sectionPayload(section, "owner_status");
    if (requestedRelease) payload.release_id=requestedRelease;
    const sequence=Number(section.dataset.summarySequence || 0)+1;
    section.dataset.summarySequence=String(sequence);section.dataset.summaryState="loading";
    if (!payload.partner_token || !section.dataset.endpoint) return;
    try {
      if (status) status.textContent = "Syncing...";
      const data = await postJson(section.dataset.endpoint, payload);
      if(Number(section.dataset.summarySequence)!==sequence)return;
      section.dataset.summaryState="ready";
      renderOwner(section, data);
      if (status) status.textContent = `${contextCopy.scope}: ${data.release_id || ""}`;
    } catch {
      if(Number(section.dataset.summarySequence)!==sequence)return;
      section.dataset.summaryState="error";
      if (status) status.textContent = copy.snapshot;
      window.dispatchEvent(new CustomEvent("kob:makeup-summary-updated"));
    }
  };

  const refreshPartner = async (section) => {
    const payload = sectionPayload(section, "status");
    if (!payload.partner_token || !section.dataset.endpoint) return;
    const data = await postJson(section.dataset.endpoint, payload);
    renderPartner(section, data, payload.partner_alias);
  };

  const submitPartner = async (section) => {
    const message = section.querySelector("[data-kob-partner-request-message]");
    const button = section.querySelector("[data-kob-partner-request-submit]");
    const payload = sectionPayload(section, "");
    if (!payload.partner_token) {
      if (message) message.textContent = copy.missingToken;
      return;
    }
    const dirty = Array.from(section.querySelectorAll(".kob-pd-request-card"))
      .filter((card) => Number(card.dataset.delta || 0) !== 0);
    if (!dirty.length) return;
    payload.lines = dirty.map((card) => {
      const input = card.querySelector("[data-kob-partner-request-code]");
      return { variant_code: input?.dataset.kobPartnerRequestCode || "", quantity: clamp(input?.value) };
    });
    if (button) button.disabled = true;
    if (message) message.textContent = copy.submitting;
    const data = await postJson(section.dataset.endpoint, payload);
    renderPartner(section, data, payload.partner_alias);
    if (message) message.textContent = copy.saved;
  };

  const run = () => {
    document.querySelectorAll("[data-kob-owner-summary-section]").forEach((section) => {
      if (section.dataset.kobMakeupDynamic === "true") return;
      section.dataset.kobMakeupDynamic = "true";
      const picker=document.createElement("label"), input=document.createElement("input"), button=document.createElement("button");
      picker.textContent=contextCopy.batch;input.value=section.dataset.releaseId || "";input.setAttribute("aria-label",contextCopy.batch);button.type="button";button.textContent=contextCopy.load;
      button.addEventListener("click",()=>{const value=input.value.trim();if(!/^MAKEUP-[0-9]{8}$/.test(value)){input.setCustomValidity("MAKEUP-YYYYMMDD");input.reportValidity();return;}input.setCustomValidity("");refreshOwner(section,value);});
      picker.append(input,button);section.prepend(picker);
      refreshOwner(section);
      window.setInterval(() => refreshOwner(section), 60000);
    });
    document.querySelectorAll("[data-kob-partner-request-section]").forEach((section) => {
      if (section.dataset.kobMakeupDynamic === "true") return;
      section.dataset.kobMakeupDynamic = "true";
      refreshPartner(section).catch(() => {});
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();

